import React from 'react';
import Icon from 'components/AppIcon';

const RecentActivity = () => {
  const recentActivities = [
    {
      id: 1,
      type: "document_upload",
      title: "Contract Amendment Uploaded",
      case: "Safaricom Ltd vs. Telkom Kenya",
      user: "Sarah Wanjiku",
      timestamp: "2 hours ago",
      status: "new",
      icon: "Upload",
      color: "bg-primary-100 text-primary"
    },
    {
      id: 2,
      type: "case_update",
      title: "Case Status Updated to \'In Progress'",
      case: "Mwangi Property Dispute",
      user: "John Kamau",
      timestamp: "4 hours ago",
      status: "updated",
      icon: "RefreshCw",
      color: "bg-warning-100 text-warning-600"
    },
    {
      id: 3,
      type: "payment_received",
      title: "Payment Received - KES 150,000",
      case: "Njoroge Divorce Proceedings",
      user: "System",
      timestamp: "6 hours ago",
      status: "completed",
      icon: "CreditCard",
      color: "bg-success-100 text-success-600"
    },
    {
      id: 4,
      type: "deadline_reminder",
      title: "Filing Deadline Approaching",
      case: "ABC Corporation Tax Appeal",
      user: "System",
      timestamp: "8 hours ago",
      status: "urgent",
      icon: "AlertTriangle",
      color: "bg-accent-100 text-accent"
    },
    {
      id: 5,
      type: "client_message",
      title: "New Message from Client",
      case: "Wanjiku Estate Planning",
      user: "Mary Wanjiku",
      timestamp: "1 day ago",
      status: "unread",
      icon: "MessageSquare",
      color: "bg-secondary-100 text-secondary-600"
    },
    {
      id: 6,
      type: "document_signed",
      title: "Power of Attorney Signed",
      case: "Kimani Real Estate Transaction",
      user: "Peter Kimani",
      timestamp: "1 day ago",
      status: "completed",
      icon: "FileCheck",
      color: "bg-success-100 text-success-600"
    }
  ];

  const getStatusBadge = (status) => {
    const badges = {
      new: "bg-primary-100 text-primary text-xs px-2 py-1 rounded-full",
      updated: "bg-warning-100 text-warning-600 text-xs px-2 py-1 rounded-full",
      completed: "bg-success-100 text-success-600 text-xs px-2 py-1 rounded-full",
      urgent: "bg-accent-100 text-accent text-xs px-2 py-1 rounded-full",
      unread: "bg-secondary-100 text-secondary-600 text-xs px-2 py-1 rounded-full"
    };
    return badges[status] || badges.new;
  };

  return (
    <div className="bg-surface rounded-lg shadow-card border border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-heading font-semibold text-text-primary">Recent Case Activity</h2>
          <button className="text-primary hover:text-primary-700 transition-smooth">
            <Icon name="RefreshCw" size={20} />
          </button>
        </div>
        <p className="text-sm text-text-secondary mt-1">Latest updates across all cases</p>
      </div>

      <div className="p-6">
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {recentActivities.map((activity) => (
            <div key={activity.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-secondary-50 transition-smooth cursor-pointer">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${activity.color}`}>
                <Icon name={activity.icon} size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h3 className="text-sm font-medium text-text-primary mb-1">
                      {activity.title}
                    </h3>
                    <p className="text-xs text-text-secondary mb-2">{activity.case}</p>
                    <div className="flex items-center space-x-2">
                      <span className="text-xs text-text-secondary">by {activity.user}</span>
                      <span className="text-xs text-text-secondary">•</span>
                      <span className="text-xs text-text-secondary">{activity.timestamp}</span>
                    </div>
                  </div>
                  <span className={getStatusBadge(activity.status)}>
                    {activity.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="w-full mt-4 py-2 text-sm text-primary hover:text-primary-700 font-medium transition-smooth">
          View All Activity
        </button>
      </div>
    </div>
  );
};

export default RecentActivity;